import type { StreamEvent } from './llm'

export function forwardStructuredEvents(
  onEvent: (event: StreamEvent) => void | Promise<void>,
  required: boolean,
  allowedToolNames?: ReadonlySet<string>,
): (event: StreamEvent) => void | Promise<void> {
  return (event) => {
    if (required && event.type === 'text-delta')
      return
    if (required && allowedToolNames && (event.type === 'tool-call' || event.type === 'tool-call-streaming-start') && !allowedToolNames.has(event.toolName))
      return
    return onEvent(event)
  }
}

export function getDisallowedToolCallResult(toolName: string, allowedToolNames: ReadonlySet<string>): string {
  const allowed = [...allowedToolNames]
  const available = allowed.length ? allowed.join(', ') : '无'
  return `工具「${toolName}」当前场景不可用，请勿重复调用。可用工具：${available}。如果没有合适的工具，请直接用普通文本回复。`
}

export function shouldUsePlainTextFallback(
  toolNames: string[],
  textContent: string,
  required: boolean | undefined,
  allowedToolNames?: ReadonlySet<string>,
): boolean {
  return !!required
    && !!allowedToolNames
    && toolNames.length > 0
    && textContent.trim().length > 0
    && toolNames.every(name => !allowedToolNames.has(name))
}
